// import React from "react";
// import { Outlet } from "react-router-dom";
// import { RequireAuth } from "@ippon/shared-auth";

// const PrivateRoute: React.FC = () => {
//   return (
//     <RequireAuth>
//       <Outlet />
//     </RequireAuth>
//   );
// };

// export default PrivateRoute;
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchMe, setRedirectPath } from "../store/authSlice";
import { AppDispatch } from "../store";
import {
  isAuthenticated,
  getRole,
  getSecureCookie,
  clearToken,
} from "../utils/authUtils";
import { buildGraceNotice, fetchContractStatus, resolveContractDenial } from "../api/contractApi";
import { useEffect, useState } from "react";
import ContractGraceBanner from "./ContractGraceBanner";

const PrivateRoute = ({ allowedRoles }: { allowedRoles?: string[] }) => {
  const authenticated = isAuthenticated();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  /** 解約後の猶予期間の案内（SPEC §7.4.6）。猶予期間でなければ null */
  const [graceNotice, setGraceNotice] = useState<string | null>(null);

  const userRole = getRole() || "";

  useEffect(() => {
    if (authenticated) {
      dispatch(fetchMe());
    }
  }, [authenticated, dispatch]);

  useEffect(() => {
    if (!authenticated) {
      // referrer_url Cookieをチェック
      const referrerUrl = getSecureCookie("referrer_url");
      if (referrerUrl) {
        setRedirectUrl(referrerUrl);
      } else {
        setRedirectUrl("/404");
      }
    }
  }, [authenticated]);

  // 契約満了アクセス制御 (SPEC §2-3): 画面遷移ごとに契約状態を確認し、
  // 契約が切れていたら強制ログアウトする。401(CONTRACT_EXPIRED) は axios が処理。
  useEffect(() => {
    if (!authenticated) return;
    let active = true;
    fetchContractStatus()
      .then((status) => {
        // 管理画面化（SPEC §7.4）：契約前 (allowed=false, CONTRACT_NOT_STARTED) も遮断する。
        // 解約後の猶予期間（allowed=true）は遮断せず、案内だけ出す（§7.4.6）
        const denied = resolveContractDenial(status);
        if (active) setGraceNotice(denied ? null : buildGraceNotice(status));
        if (active && denied) {
          sessionStorage.setItem("logoutReason", denied);
          clearToken();
          window.location.href = "/login";
        }
      })
      .catch(() => {
        // ネットワーク/認可エラーは握りつぶす (401 は interceptor が強制ログアウト)
      });
    return () => {
      active = false;
    };
  }, [location.pathname, authenticated]);

  if (!userRole && !authenticated) {
    // 一時的に
    dispatch(setRedirectPath(location.pathname + location.search));

    if (redirectUrl) {
      window.location.href = redirectUrl;
      return null;
    }
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  if (!authenticated) {
    // Save current location for redirect after login
    dispatch(setRedirectPath(location.pathname + location.search));

    if (redirectUrl) {
      window.location.href = redirectUrl;
      return null;
    }
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {graceNotice && <ContractGraceBanner message={graceNotice} />}
      <Outlet />
    </>
  );
};

export default PrivateRoute;
